import script from "./EmailForm.vue?vue&type=script&setup=true&lang=js"
export * from "./EmailForm.vue?vue&type=script&setup=true&lang=js"

import "./EmailForm.vue?vue&type=style&index=0&id=f91abfda&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./EmailForm.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f91abfda"]])

export default __exports__